import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/_guards';
import { FormGuard } from './auth/_guards/form.guard';
import { CadastrarEditalComponent } from './pages/cadastrar-edital/cadastrar-edital.component';
import { FormularioSolicitacaoEditarComponent } from './pages/formulario-solicitacao/editar/formulario-solicitacao-editar.component';
import { FormularioSolicitacaoComponent } from './pages/formulario-solicitacao/formulario-solicitacao.component';
import { ListarInscritosComponent } from './pages/listar-inscritos/listar-inscritos.component';
import { LoginExternoComponent } from './pages/login/login-externo/login-externo.component';
import { LoginComponent } from './pages/login/login.component';
import { RelacaoInscritosComponent } from './pages/relacao-inscritos/relacao-inscritos.component';
import { SolicitacaoAdvogadoComponent } from './pages/solicitacao-advogado/solicitacao-advogado.component';
import { SolicitacaoComponent } from './pages/solicitacao/solicitacao.component';


const routes: Routes = [

  { path: 'login', component: LoginComponent },
  { path: 'listar-inscritos', component: ListarInscritosComponent, canActivate: [AuthGuard], data: { roles: ['ADM'] }},
  { path: 'solicitacao', component: SolicitacaoComponent, canActivate: [AuthGuard] ,  data: { roles: ['ADVOGADO', 'ADM'] }},
  { path: 'formulario', component: FormularioSolicitacaoComponent, canActivate: [FormGuard, AuthGuard], data: { roles: ['ADVOGADO', 'ADM'] }},
  { path: 'formulario/:acao/:idRequerimento', component: FormularioSolicitacaoComponent, canActivate: [FormGuard, AuthGuard], data: { roles: ['ADVOGADO'] }},
  { path: 'formulario/:idRequerimento', component: FormularioSolicitacaoEditarComponent, canActivate: [FormGuard, AuthGuard], data: { roles: ['ADM'] }},
  { path: 'impressao-inscritos', component: RelacaoInscritosComponent},
  { path: 'cadastro-edital', component: CadastrarEditalComponent, canActivate: [AuthGuard], data: { roles: ['ADM'] }},
  { path: 'listar-solicitacoes-advogado', component: SolicitacaoAdvogadoComponent, canActivate: [AuthGuard],  data: { roles: ['ADVOGADO'] }},
  { path: 'login-externo', component: LoginExternoComponent },
  { path: '**', redirectTo: 'login-externo' },
  { path: '', redirectTo: 'login-externo', pathMatch: 'full' }

];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)],
  providers: []
})
export class AppRoutingModule {

}
